/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_GithubInputs */

const en_gc_footer_github = /** @type {(inputs: Gc_Footer_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source on GitHub`)
};

const zh_gc_footer_github = /** @type {(inputs: Gc_Footer_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub 源码`)
};

/**
* | output |
* | --- |
* | "Source on GitHub" |
*
* @param {Gc_Footer_GithubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_github = /** @type {((inputs?: Gc_Footer_GithubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_GithubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_github(inputs)
	return zh_gc_footer_github(inputs)
});
export { gc_footer_github as "gc.footer.github" }